module.exports = __webpack_public_path__ + "c179c8f264df4b31eab6c71a532f7599.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-LightItalic.woff2
// module id = 364
// module chunks = 0